import {
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { ToasterService } from '../../../services/toaster.service';

@Component({
  selector: 'app-direct-ship',
  templateUrl: './direct-ship.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class DirectShipComponent implements OnInit {
  index = 1;
  public isLoading;
  public companyId;
  public company: any = {send_direct_email: null};

  constructor(private translate: TranslateService,
              private toasterService: ToasterService,
              private request: RequestsServices,
              private route: ActivatedRoute,
              private router: Router,
              private storage: StorageService,
              private userService: UserService) {

    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    navigator.language === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.company = {...this.userService.getLoggedAccount()};
  }

  public setTypeShip(value: string): void {
    this.isLoading = true;
    this.company.send_direct_email = value;
    this.request.put('companies', this.company).then((company) => {
      this.isLoading = false;
      if (company) {
        this.userService.requestAccountConfig();
        this.toasterService.info('Sucesso', 'Opção de envio direto atualizada!', true, 2000);
      }
    });
  }
}
